import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";
import { styled } from "@mui/material/styles";
import { theme as _theme } from "../../helpers/theme";
import { ReactComponent as Checked } from "../../assets/icons/_checked.svg";
import { ReactComponent as UnChecked } from "../../assets/icons/_unchecked.svg";
import { FormControlLabel, FormControlLabelProps } from "@mui/material";

export const StyledCheckbox = styled((props: CheckboxProps) => (
  <Checkbox icon={<UnChecked />} checkedIcon={<Checked />} {...props} />
))(({ theme }) => ({
  "&.Mui-checked": {},

  ":disabled": {},
  "&:hover": {
    color: `${_theme.colors.gray04_background}`,
    backgroundColor: `${_theme.colors.gray04_background}`,
  },
}));
// export const CheckboxStyle = styled(Checkbox)<CheckboxProps>(({ theme }) => ({
//   "&.Mui-checked": {},

//   ":disabled": {},
//   "&:hover": {
//     color: `${_theme.colors.gray04_background}`,
//     backgroundColor: `${_theme.colors.gray04_background}`,
//   },
// }));

// export const FormControlLabelStyle = styled(
//   FormControlLabel
// )<FormControlLabelProps>(({ theme, checked }) => ({
//   "&.MuiFormControlLabel-root": {
//     fontFamily: `${_theme.fonts.interRegular}`,
//     fontStyle: "normal",
//     fontWeight: `${_theme.fontWeight.normal}`,
//     fontSize: "14px",
//     lineHeight: "20px",
//     color: `${_theme.colors.gray01_secondaryText}`,
//   },
// }));
